import { create } from 'zustand';
import { syncTeamFlowCanvasReadonly } from '../utils/syncTeamFlowCanvasReadonly';

const CLIPPER_DEBUG_PREFIX = '[TeamFlowClipperDebug]';

interface TeamFlowClipperState {
  visible: boolean;
  everOpened: boolean;
  fullscreenOpen: boolean;
  /** mini 时间轴是否正在等待 detail / 回显，用于展示轨道 loading。 */
  timelineHydrating: boolean;
  /** 进入全屏前 mini 是否可见，用于关闭全屏后恢复。 */
  wasVisibleBeforeFullscreen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
  enterFullscreen: () => void;
  exitFullscreen: () => void;
  /** 完全关闭剪辑器（mini / 全屏），不恢复 mini。 */
  dismiss: () => void;
  setVisible: (visible: boolean) => void;
  setTimelineHydrating: (hydrating: boolean) => void;
  markOpened: () => void;
}

/**
 * 控制画布底部 mini 时间轴剪辑器的显隐状态。
 */
export const useTeamFlowClipperStore = create<TeamFlowClipperState>((set) => ({
  visible: false,
  everOpened: false,
  fullscreenOpen: false,
  timelineHydrating: false,
  wasVisibleBeforeFullscreen: false,
  open: () => {
    set({ visible: true, everOpened: true, fullscreenOpen: false });
    syncTeamFlowCanvasReadonly();
  },
  close: () => {
    set({
      visible: false,
    });
    syncTeamFlowCanvasReadonly();
  },
  toggle: () => {
    set((state) => ({
      visible: !state.visible,
      everOpened: state.everOpened || !state.visible,
      fullscreenOpen: state.visible ? state.fullscreenOpen : false,
    }));
    syncTeamFlowCanvasReadonly();
  },
  enterFullscreen: () => {
    set((state) => ({
      wasVisibleBeforeFullscreen: state.visible,
      visible: false,
      everOpened: true,
      fullscreenOpen: true,
    }));
    console.debug(CLIPPER_DEBUG_PREFIX, 'store enterFullscreen', useTeamFlowClipperStore.getState());
    syncTeamFlowCanvasReadonly();
  },
  exitFullscreen: () => {
    set((state) => {
      if (!state.fullscreenOpen) {
        return state;
      }
      return {
        fullscreenOpen: false,
        visible: state.wasVisibleBeforeFullscreen,
        everOpened: state.everOpened || state.wasVisibleBeforeFullscreen,
        wasVisibleBeforeFullscreen: false,
      };
    });
    console.debug(CLIPPER_DEBUG_PREFIX, 'store exitFullscreen', useTeamFlowClipperStore.getState());
    syncTeamFlowCanvasReadonly();
  },
  dismiss: () => {
    set({
      visible: false,
      fullscreenOpen: false,
      wasVisibleBeforeFullscreen: false,
    });
    console.debug(CLIPPER_DEBUG_PREFIX, 'store dismiss', useTeamFlowClipperStore.getState());
    syncTeamFlowCanvasReadonly();
  },
  setVisible: (visible) => {
    set((state) => ({
      visible,
      everOpened: state.everOpened || visible,
      fullscreenOpen: visible ? false : state.fullscreenOpen,
      timelineHydrating: visible ? state.timelineHydrating : false,
    }));
    syncTeamFlowCanvasReadonly();
  },
  setTimelineHydrating: (timelineHydrating) => set({ timelineHydrating }),
  markOpened: () => set((state) => (state.everOpened ? state : { everOpened: true })),
}));
